/**
 * Grupo de PDF de um item na remissão.
 *
 * O DocumentVisualization gera um PDF separado por grupo (medicamento simples,
 * suplemento, fitoterápico, controle especial, exame geral, laboratorial, imagem,
 * procedimento). A remissão assina só UM PDF, então uma edição que muda o item
 * de grupo (troca de aba, tarja especial, categoria do exame) geraria outro PDF
 * que não seria assinado. Mesmas regras de separação do InterventionsContext /
 * DocumentVisualization.
 */

const LAB_CATEGORY_CODE = "108252007";
const IMAGE_CATEGORY_CODE = "363679005";

/** Tarja especial — mesma regra de `selectedInterventions.medicationSpecial`. */
function isSpecialTag(tag: any): boolean {
  const upper = typeof tag === "string" ? tag.toUpperCase() : "";
  return (
    upper.includes("VERMELHA") ||
    upper.includes("PRETA") ||
    upper.includes("ESPECIAL")
  );
}

/** Chave do grupo de PDF onde o item será renderizado. */
export function getReissuePdfGroup(item: any): string {
  if (isSpecialTag(item?.tag)) return "special";

  if (item?.type === "service") {
    const code = item?.category?.code;
    if (code === LAB_CATEGORY_CODE) return "service-lab";
    if (code === IMAGE_CATEGORY_CODE) return "service-image";
    return "service-general";
  }

  return item?.type || "unknown";
}

/** Conjunto de grupos dos itens hidratados do documento original. */
export function collectReissuePdfGroups(items: any[]): Set<string> {
  return new Set((items || []).map(getReissuePdfGroup));
}

/** true se algum item atual caiu num grupo que o documento original não tinha. */
export function hasItemOutsideOriginalGroups(
  items: any[],
  originalGroups: Set<string>,
): boolean {
  return (items || []).some(
    (item) => !originalGroups.has(getReissuePdfGroup(item)),
  );
}
